import React, { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector} from "react-redux";
import { postWorkshopList,postWorkshopCount } from "../../redux/workshops/thunks";
import { getContractByCaseId, } from "../../redux/contract/thunks";
import { selectWorkshopFilters, selectWorkshops } from "../../redux/workshops/selectors";
import Table from "./Table";
import {Columnas} from "../../Constantes/constantesColumnasTablas";
import CustomPagination from "./CustomPagination";
import TableForm from "../tableform/TableForm";
import { selectCaseFilters, selectCases } from "../../redux/cases/selectors";
import { isCaseBlockedByUser, postCaseList,updateCaseList, postCaseCount, setNotManaged } from "../../redux/cases/thunks";
import {ROUTE_LOGIN, ROUTE_PANEL} from "../routes/routesConstants";
import { useHistory } from "react-router";
import { clearWorkshopError, setWorkshopFilters } from "../../redux/workshops/workshopSlice";
import { clearCaseError, setCaseFilters } from "../../redux/cases/casesSlice";
import {getCaseStates} from "../../redux/caseStates/thunks";
import { selectVehicleFilters, selectVehicles } from "../../redux/vehicles/selectors";
import {getProvinces} from "../../redux/provinces/thunks";
import { postVehicleList,postVehicleCount } from "../../redux/vehicles/thunks";
import { selectCustomerFilters, selectCustomers, selectAllCustomers } from "../../redux/customers/selectors";
import { postCustomerList,postCustomerCount, getAllCustomers } from "../../redux/customers/thunks";
import {clearCustomerError, setCustomerFilters} from "../../redux/customers/customersSlice";
import {clearVehicleError, setVehicleFilters} from "../../redux/vehicles/vehiclesSlice";
import { postItvList,postItvCount } from "../../redux/itvs/thunks";
import {clearItvError, setItvFilters} from "../../redux/itvs/itvsSlice";
import {selectCaseStates} from "../../redux/caseStates/selectors";
import {selectItvFilters, selectItvs} from "../../redux/itvs/selectors";
import {selectProvinces} from "../../redux/provinces/selectors";
import { parseJwtToken,_base64ToArrayBuffer,getUTCOffset, getTimeZone} from "../../commonFunctions/commonFunctions";
import {QUERY_POST_EXPORT_EXCEL} from "../../fetch/constantQueries";
import { openModal } from "../../redux/modal/modalSlice";
import dayjs from "dayjs";
import { baseRequest } from "../../fetch/basicThunk";
import saveAs from 'file-saver';
import defaultStartDateFilter from "../../Constantes/defaultStartDateFilter.json";
import { errorHandler } from "../../commonFunctions/errorHandler";
import { getEntryChannels } from "../../redux/entryChannels/thunks";
import { selectEntryChannels } from "../../redux/entryChannels/selectors";
import DataSource from 'devextreme/data/data_source';
import { getUserServices } from "../../redux/services/thunks";
import { selectUserServices } from "../../redux/services/selectors";
import { getSuppliers } from "../../redux/suppliers/thunks";
import { getSupplierServiceTypes } from "../../redux/supplierServiceTypes/thunks";
import { selectSuppliers } from "../../redux/suppliers/selectors";
import { selectSupplierServiceTypes } from "../../redux/supplierServiceTypes/selectors";

function TableWrapper(props) {

    const {type} = props;
    const firstTime = useRef(true);
    const history = useHistory();
    const dispatch = useDispatch();
    const {selector, dispatchSearch,dispatchCount,dispatchClearError, defaultSearchfield,defaultOrderAsc, filterSelector, filterSetter, defaultStartDate} = pickByType(type)
    const {list, loading, error} = useSelector(selector);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const caseStates = useSelector(selectCaseStates);
    const [subStates, setSubStates] = useState([]);
    const entryChannels = useSelector(selectEntryChannels);
    const suppliers = useSelector(selectSuppliers);
    const supplierServiceTypes = useSelector(selectSupplierServiceTypes);
    const filters = useSelector(filterSelector);
    const userServices = useSelector(selectUserServices);
    const provinces = useSelector(selectProvinces);
    const allCustomers = useSelector(selectAllCustomers);
    const [pageSize, setPagesize] = useState(15);
    const [pageIndex, setPageIndex] = useState(1);
    const [selectedRows,setSelectedRows] = useState(null);
    const [enableChangeState,setEnableChangeState] = useState(false);
    const [searchText,setSearchText] = useState("");
    const [filterKey, setFilterKey] = useState(0);

    const [userServicesAux, setUserServicesAux] = useState(null);
    const [filtersLoaded, setFiltersLoaded] = useState(false);

    const [datos,setDatos] = useState(
    filters ? {...filters} :
    {
        busquedaGeneral: '',
        fechaInicio: defaultStartDate,
        fechaInicioHasta: null,
        estado: null,
        taxonomies: null,
        provincias: null,
        columna: defaultSearchfield,
        orderAsc: defaultOrderAsc,
        entryChannels:null,
        subEstados: null,
        premium: null,
        servicios: userServices, // EDITED null
        customerCode: null,
    }
)

function pickByType(type){
const result= {selector, dispatchSearch, dispatchClearError, dispatchCount, defaultSearchfield,defaultOrderAsc, filterSelector}
    result.defaultOrderAsc = true;
    switch (type){
        case "Talleres":
            result.selector = selectWorkshops;
            result.dispatchSearch = postWorkshopList;
            result.dispatchClearError = clearWorkshopError;
            result.defaultSearchfield = "name";
            result.dispatchCount = postWorkshopCount;
            result.filterSelector = selectWorkshopFilters;
            result.filterSetter = setWorkshopFilters;
        break;
        case "Casos":
            result.selector = selectCases;
            result.dispatchSearch = postCaseList;
            result.dispatchClearError = clearCaseError;
            result.dispatchCount = postCaseCount;
            result.defaultSearchfield = "creationDate"
            result.defaultOrderAsc = false;
            result.filterSelector = selectCaseFilters;
            result.filterSetter = setCaseFilters;
            result.defaultStartDate = dayjs(new Date().setMonth(new Date().getMonth() - defaultStartDateFilter.monthLimit)).format("YYYY-MM-DD");
        break;
        case "Flotas":
            result.selector = selectVehicles;
            result.dispatchSearch  = postVehicleList;
            result.dispatchCount = postVehicleCount;
            result.dispatchClearError = clearVehicleError;
            result.defaultSearchfield = "model";
            result.filterSelector = selectVehicleFilters;
            result.filterSetter = setVehicleFilters;
        break;
        case "Clientes":
            result.selector = selectCustomers;
            result.dispatchSearch  = postCustomerList;
            result.dispatchCount = postCustomerCount;
            result.dispatchClearError = clearCustomerError;
            result.defaultSearchfield = "customerCode"
            result.filterSelector = selectCustomerFilters;
            result.filterSetter = setCustomerFilters;
        break;
        case "Itvs":
            result.selector = selectItvs;
            result.dispatchSearch  = postItvList;
            result.dispatchCount = postItvCount;
            result.dispatchClearError = clearItvError;
            result.defaultSearchfield = "region";
            result.filterSelector = selectItvFilters;
            result.filterSetter = setItvFilters;
        break;
        default:
            result.selector = selectWorkshops
            result.dispatchSearch  = postWorkshopList;
            result.dispatchCount = postItvCount;
            result.dispatchClearError = clearWorkshopError;
            result.defaultSearchfield = "name"
    }
    return result
}


let mostrarBusquedaAvanzada =  true;
switch (type) {
    case "Talleres": {
        mostrarBusquedaAvanzada = false;
    }
}

const columnasTabla = Columnas()[type];


//#region  funciones handlers

function handleCustomerChange(e) {
    const value = e.value && e.value.length > 0 ? (Array.isArray(e.value) ? e.value.join(",") : e.value) : null;
    setDatos(prevState => {
        if (prevState.customerCode === value) {
            return prevState;
        }
        return {
            ...prevState,
            customerCode: value
        };
    });
}

function handleProvinceChange (e) {
    let provincias = e.value && e.value.length > 0 ? e.value : null;
    setDatos(prevState => {
        const prevStr = prevState.provincias ? prevState.provincias.join(",") : null;
        const newStr = provincias ? provincias.join(",") : null;
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            provincias: provincias
        };
    });
}

function handleServiceChange(e){
    let servicios = e.value && e.value.length > 0 ? e.value.filter(e=>e) : null;
    setDatos(prevState=>({
        ...prevState,
        servicios: servicios,
        taxonomies: null
    }))
}

function handlePremiumChange(e){
    setDatos(prevState=> ({...prevState, premium: e.value}))
}

function handleSupplierChange(e) {
    let selectedSuppliers = e.value && e.value.length > 0 ? e.value : null;
    setDatos(prevState => {
        const prevStr = prevState.suppliers ? prevState.suppliers.join(",") : null;
        const newStr = selectedSuppliers ? selectedSuppliers.join(",") : null;
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            suppliers: selectedSuppliers
        };
    });
}

function handleSupplierServiceTypeChange(e) {
    let selectedServiceTypes = e.value && e.value.length > 0 ? e.value : null;
    setDatos(prevState => {
        const prevStr = prevState.supplierServiceTypes ? prevState.supplierServiceTypes.join(",") : null;
        const newStr = selectedServiceTypes ? selectedServiceTypes.join(",") : null;
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            supplierServiceTypes: selectedServiceTypes
        };
    });
}

async function exportExcel () {
   let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;

    const submitData = {
        master:type,
        timeZone : getTimeZone(),
        pageInfo:{ 
            pageIndex: pageIndex-1,
            orderByAscending: datos.orderAsc,
            orderByField: datos.columna,
            searchString: searchText,
            creationDateUntil: datos.fechaInicioHasta,
            creationDate: datos.fechaInicio,
            master:type,
            caseTaxonomies: taxonomies?taxonomies.join(","):null,
            caseStates:datos.estado != null ? datos.estado.toString() : null,
            subStates:datos.subEstados != null ? datos.subEstados.toString() : null,
            provinces: datos.provincias != null ? datos.provincias.toString() : null,
            entryChannels: datos.entryChannels != null? datos.entryChannels.join(",") : null,
            caseServices: datos.servicios != null? datos.servicios.join(",") : null,
            utcOffset : getUTCOffset(),
            premium: datos.premium != null ? datos.premium.join(",")  : null,
            suppliers: datos.suppliers != null ? datos.suppliers.join(",") : null,
            supplierServiceTypes: datos.supplierServiceTypes != null ? datos.supplierServiceTypes.join(",") : null
        }
    }
    setLoadingExcel(true)
    
    try {
    const data = await baseRequest({body: submitData}, dispatch, QUERY_POST_EXPORT_EXCEL, "POST");
    if (data != "") {
        const fecha = "_"+dayjs().format('YYYYMMDD')+"_"+dayjs().format("HHmmss");
        saveAs(new Blob([ _base64ToArrayBuffer(data)], { type: 'application/octet-stream' }), type+fecha+'.xlsx');
        } else {
            dispatch(openModal({ type: "warning", message:"No hay datos para exportar."}));
            }  
    
    } catch (error) {
     
        dispatch(openModal(errorHandler(error)));
    
    } finally{

        setLoadingExcel(false)
    
    }  
}

function onOptionChanged (e) {
    if ( (e.name == "columns" && e.value == undefined) && (e.column == undefined || e.column.type !== "selection"))
    {
        setTimeout(() => {
            dispatch(dispatchSearch({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": true,"orderByField": defaultSearchfield,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
            if (dispatchCount != null)
            dispatch(dispatchCount({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": true,"orderByField": defaultSearchfield,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias,master:type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
        }, 100);

    }
}


function handleCellClick (e) {

    if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons")) {
        let columna = e.column.dataField;
        let sortOrder = e.column.sortOrder;
        if (sortOrder == undefined || sortOrder == "undefined") {

            e.column.sortOrder = 'asc';

        }

        else if (sortOrder == 'desc') {

            e.column.sortOrder = 'asc';

        }

        else if (sortOrder == 'asc') {

            e.column.sortOrder = 'desc';

        }

        let orden = e.column.sortOrder == 'asc' ? true : false;
        let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null

        dispatch(dispatchSearch({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": orden,"orderByField": columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias, "caseStates":datos.estado,"provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
        if (dispatchCount != null)
            dispatch(dispatchCount({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": orden,"orderByField": columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels, master:type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));

        setDatos(prevState => ({
            ...prevState,
            columna:columna,
            orderAsc: orden,
         }));
         setPageIndex(1);

         dispatch(filterSetter({
            ...datos,
            busquedaGeneral: datos.busquedaGeneral,
            orderAsc: orden,
            pageSize,
            columna,
            pageIndex: 1
        }))       
    }
}

function handleRowClick (e) {

    if (e.rowType !== "header") {
        if(type === "Casos") {
            dispatch(isCaseBlockedByUser({query:`?caseId=${e.key.caseId}`})).then((data) => {
                if (data.payload) {
                    dispatch(getContractByCaseId({query: "?caseId="+ e.key.caseId})).unwrap().then( () => history.push(ROUTE_PANEL) );           
                } else if (data.payload === false) {
                    dispatch(openModal({ type: "warning", message:"El caso esta bloqueado por otro usuario."}));
                }
            });    
        } else if (type === "Flotas") {
            history.push(ROUTE_PANEL, {plate: e.key.plate});
        }
    }
}

function handleSelectedRow (e) {
    let arrayIds = [];
    e.map((value,index) => {
        arrayIds.push(value.caseId);
    })
    setSelectedRows(arrayIds);
}

function handleChangeStateCases (stateId, substateId) {
    let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;
    const updateParams = {
        pageNum: pageSize,
        pageIndex: pageIndex-1,
        orderByAscending: datos.orderAsc,
        orderByField: datos.columna,
        searchString: datos.busquedaGeneral,
        ids:selectedRows,
        stateId: stateId,
        subStateId: substateId? substateId : null,
        utcOffset:getUTCOffset(),
        creationDateUntil:datos.fechaInicioHasta,
        creationDate:datos.fechaInicio,
        caseStates:datos.estado != null ? datos.estado.toString() : null,
        subStates:datos.subEstados != null ? datos.subEstados.toString() : null,
        caseTaxonomies:taxonomies?taxonomies.join(","): null,
        entryChannels:datos.entryChannels!= null ? datos.entryChannels.toString() : null,
    }
    dispatch(updateCaseList(updateParams));
}

function handleSetNotManaged () {
    let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;
    const updateParams = {
        pageNum: pageSize,
        pageIndex: pageIndex-1,
        orderByAscending: datos.orderAsc,
        orderByField: datos.columna,
        searchString: datos.busquedaGeneral,
        ids:selectedRows,
        utcOffset:getUTCOffset(),
        creationDateUntil:datos.fechaInicioHasta,
        creationDate:datos.fechaInicio,
        caseStates:datos.estado != null && datos.estado.length>0? datos.estado.toString() : null,
        caseTaxonomies:taxonomies?taxonomies.join(","): null,
        entryChannels:datos.entryChannels!= null ? datos.entryChannels.toString() : null,
    }
    dispatch(setNotManaged(updateParams));
}

function handlePageSizeChange(value) {
    dispatch(dispatchSearch({pagination:{pageNum: value, pageIndex: 0,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode,  "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}))
    if (dispatchCount != null)
        dispatch(dispatchCount({pagination:{pageNum: value, pageIndex: 0,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias,master:type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}))
    setPagesize(value);
    setPageIndex(1)
    dispatch(filterSetter({
        ...datos,
        pageIndex: 1,
        pageSize: value,
    }))
}

const handlePageIndexChange = (event, value) => {
    let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;
    dispatch(dispatchSearch({pagination:{pageNum: pageSize, pageIndex:value-1,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
    if (dispatchCount != null)
        dispatch(dispatchCount({pagination:{pageNum: pageSize, pageIndex:value-1,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado,"provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels, "master":type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
    setPageIndex(value);
    dispatch(filterSetter({
        ...datos,
        pageSize,
        pageIndex: value,
    }))
};

function handleRefreshPage() {
    let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;
    dispatch(dispatchSearch({pagination:{pageNum: pageSize, pageIndex: pageIndex-1,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado, "subStates":datos.subEstados, "provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
    if (dispatchCount != null)
        dispatch(dispatchCount({pagination:{pageNum: pageSize, pageIndex: pageIndex-1,"orderByAscending": datos.orderAsc,"orderByField": datos.columna,"searchString": datos.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":datos.fechaInicioHasta,"creationDate":datos.fechaInicio,"caseStates":datos.estado, "subStates":datos.subEstados, "provinces":datos.provincias,"caseTaxonomies":taxonomies, "entryChannels": datos.entryChannels,master:type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}))
}

function handleInputChange (e) {
    if (e.component === undefined) {
        setDatos(prevState => {
            if (prevState.busquedaGeneral === e) {
                return prevState;
            }
            return {
                ...prevState,
                busquedaGeneral: e
            };
        });
    }
}

function handleInputClear (e) {
    setDatos(prevState => ({
        ...prevState,
        busquedaGeneral: ''
    }));
}

function handleFechaIniChange (e) {
    setDatos(prevState => {
        if (prevState.fechaInicio === e.value) {
            return prevState;
        }
        return {
            ...prevState,
            fechaInicio: e.value
        };
    });
}

function handleFechaInicioHastaChange (e) {
    setDatos(prevState => {
        if (prevState.fechaInicioHasta === e.value) {
            return prevState;
        }
        return {
            ...prevState,
            fechaInicioHasta: e.value
        };
    });
}

function handleBoxChange(e) {
    let estados = e.value && e.value.length > 0 ? e.value : null;
    setDatos(prevState => {
        const prevStr = prevState.estado ? prevState.estado.join(",") : null;
        const newStr = estados ? estados.join(",") : null;
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            estado: estados,
        };
    });
}

function handleEntryChannelChange(e) {
    let entryChannels = e.value && e.value.length > 0 ? e.value : null;
    setDatos(prevState => {
        const prevStr = prevState.entryChannels ? prevState.entryChannels.join(",") : null;
        const newStr = entryChannels ? entryChannels.join(",") : null;
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            entryChannels: entryChannels
        };
    });
}

function handleTaxonomiesChange(e) {
    let taxonomies = e && e.length > 0 ? e : [];
    setDatos(prevState => {
        const prevStr = prevState.taxonomies ? prevState.taxonomies.join(",") : "";
        const newStr = taxonomies ? taxonomies.join(",") : "";
        if (prevStr === newStr) {
            return prevState;
        }
        return {
            ...prevState,
            taxonomies
        };
    });
}

function handleSubStateChange(e) {
    let subEstados = e.value.length > 0 ? e.value.filter(e=>e) : null;

    setDatos(prevState => ({
        ...prevState,
        subEstados: subEstados
     }));
}

function clearFilters() {
    setDatos({
        busquedaGeneral: '',
        fechaInicio: defaultStartDate,
        fechaInicioHasta: null,
        estado: null,
        taxonomies: null,
        columna: defaultSearchfield,
        orderAsc: defaultOrderAsc,
        entryChannels: null,
        subEstados: null,
        premium: null,
        servicios: userServices,
        customerCode: null,
        suppliers: null,
        supplierServiceTypes: null
    });
    setFilterKey(prev => prev + 1);
    handleSubmit(null, true);
}

function checkEnter (e) {
    if ( (e.charCode != undefined && e.charCode === 13) ||  (e.event != undefined && e.event.keyCode == 13)) {
        let evento;
        if (e.event == undefined) {
            e.preventDefault();
            evento = e;
        }
        else {
            e.event.preventDefault();
            evento = e.event;
        }
        handleSubmit(evento);
    }
}

function handleSubmit (event,clear = false) {

    if (event != null ) {
        let e = event.event == undefined ? event : event.event;
        e.preventDefault();
    }

    let datosSubmit = clear == true ? {
        busquedaGeneral: '',
        fechaInicio: defaultStartDate,
        fechaInicioHasta: null,
        estado: null,
        taxonomies: null,
        columna: defaultSearchfield,
        orderAsc: defaultOrderAsc,
        entryChannels: null,
        subEstados: null,
        premium: null,
        servicios: userServices, // EDITED null
        customerCode: null,
        suppliers: null,
        supplierServiceTypes: null
    } : datos;
    
    let busqueda =  clear == false ? datosSubmit.busquedaGeneral : '';
    dispatch(filterSetter({
        ...datosSubmit,
        busquedaGeneral: busqueda,
        pageSize,
        pageIndex: 1
    }));

    let taxonomies = datosSubmit.taxonomies ? convertTaxonomies(datosSubmit.taxonomies) : null;
    dispatch(dispatchSearch({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": datosSubmit.orderAsc,"orderByField": datosSubmit.columna,"searchString":(busqueda.trim()),"utcOffset":getUTCOffset(),"creationDateUntil":datosSubmit.fechaInicioHasta,"creationDate":datosSubmit.fechaInicio,"caseStates":datosSubmit.estado,"provinces":datosSubmit.provincias, "caseTaxonomies": taxonomies, "entryChannels": datosSubmit.entryChannels, "subStates": datosSubmit.subEstados, "premium": datosSubmit.premium, "caseServices": datosSubmit.servicios, "customerCode": datosSubmit.customerCode, "suppliers": datosSubmit.suppliers, "supplierServiceTypes": datosSubmit.supplierServiceTypes,}}));
    if (dispatchCount != null)
        dispatch(dispatchCount({pagination:{pageNum: pageSize, pageIndex: 0,"orderByAscending": datosSubmit.orderAsc,"orderByField": datosSubmit.columna,"searchString":(busqueda.trim()),"utcOffset":getUTCOffset(),"creationDateUntil":datosSubmit.fechaInicioHasta,"creationDate":datosSubmit.fechaInicio,"caseStates":datosSubmit.estado,"provinces":datosSubmit.provincias, "caseTaxonomies": taxonomies, "entryChannels": datosSubmit.entryChannels,master:type, "subStates": datosSubmit.subEstados, "premium": datosSubmit.premium, "caseServices": datosSubmit.servicios, "customerCode": datosSubmit.customerCode, "suppliers": datosSubmit.suppliers, "supplierServiceTypes": datosSubmit.supplierServiceTypes,}}));
    setPageIndex(1);
    setSearchText(busqueda);
}

function convertTaxonomies(taxonomies) {
    let idList = [];
    taxonomies.forEach(taxonomy => {
        idList.push(Number(taxonomy.split(':')[0]));
    });
    return idList;
}

//#endregion

useEffect(()=>{

    const fetchData = async () => {
        try {
            let isAdmin = false;
            let user = parseJwtToken();
            if ( user != null && user.role != null) {
                let roles = Array.isArray(user.role) ? user.role : [user.role];
                roles.map((value,index) => {
                    if (value == "admin") {
                        isAdmin = true;
                        setEnableChangeState(true);
                    }
                });
            }

            let tempUserServices = null;
            firstTime.current = false;
            if(type === "Casos" && list.elements.length === 0){
                await dispatch(getAllCustomers());
                await dispatch(getCaseStates());
                await dispatch(getSuppliers());
                await dispatch(getSupplierServiceTypes());
            };
            if(type === "Casos" && list.elements.length === 0){
                
                if(isAdmin){
                    dispatch(getUserServices())
                }
                else {
                    tempUserServices = await dispatch(getUserServices()).unwrap()
                    tempUserServices = tempUserServices.map(s => s.serviceId)
                    
                    setDatos(prevState=>({
                        ...prevState,
                        servicios: tempUserServices,
                    }))
                }
            };
            if(type === "Casos" && list.elements.length === 0){await dispatch(getEntryChannels())};
            if(type === "Itvs" && list.elements.length === 0){await dispatch(getProvinces())};
        

            if (filters){
                let taxonomies = datos.taxonomies ? convertTaxonomies(datos.taxonomies) : null;
                setPageIndex(filters.pageIndex ? filters.pageIndex : 1);
                setPagesize(filters.pageSize ? filters.pageSize : 15)
                dispatch(dispatchSearch({pagination:{pageNum: filters.pageSize ? filters.pageSize:15, pageIndex: filters.pageIndex ? filters.pageIndex-1:0,"orderByAscending": (filters.orderAsc === true || filters.orderAsc === false) ? filters.orderAsc : defaultOrderAsc,"orderByField": filters.columna ? filters.columna : defaultSearchfield,
                "searchString": filters.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":filters.fechaInicioHasta ? filters.fechaInicioHasta : '',"creationDate":filters.fechaInicio ? filters.fechaInicio : '',"caseStates":filters.estado ? filters.estado: '', "subStates":filters.subEstados ? filters.subEstados: '' , "provinces": filters.provincias? filters.provincias.join(",") : "" , "caseTaxonomies": taxonomies, "entryChannels": datos.entryChannels, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
                if (dispatchCount != null)
                    dispatch(dispatchCount({pagination:{pageNum: filters.pageSize ? filters.pageSize:15, pageIndex: filters.pageIndex ? filters.pageIndex-1:0,"orderByAscending": (filters.orderAsc === true || filters.orderAsc === false)  ? filters.orderAsc : defaultOrderAsc,"orderByField": filters.columna ? filters.columna : defaultSearchfield,
                "searchString": filters.busquedaGeneral,"utcOffset":getUTCOffset(),"creationDateUntil":filters.fechaInicioHasta ? filters.fechaInicioHasta : '',"creationDate":filters.fechaInicio ? filters.fechaInicio : '',"caseStates":filters.estado ? filters.estado: '', "subStates":filters.subEstados ? filters.subEstados: '' , "provinces": filters.provincias? filters.provincias.join(",") : "" , "caseTaxonomies": taxonomies, "entryChannels": datos.entryChannels,"master":type, "premium": datos.premium, "caseServices": datos.servicios, "customerCode": datos.customerCode, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
            } else {
                dispatch(dispatchSearch({pagination:{pageNum: 15, pageIndex: 0,"orderByAscending": defaultOrderAsc,"orderByField": defaultSearchfield,"searchString": "", "creationDate": defaultStartDate, "utcOffset":getUTCOffset(), "premium": datos.premium, "caseServices": tempUserServices, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
                if (dispatchCount != null)
                    dispatch(dispatchCount({pagination:{pageNum: 15, pageIndex: 0,"orderByAscending": defaultOrderAsc,"orderByField": defaultSearchfield,"searchString": "", "creationDate": defaultStartDate, "utcOffset":getUTCOffset(),"master":type, "premium": datos.premium, "caseServices": tempUserServices, "suppliers": datos.suppliers, "supplierServiceTypes": datos.supplierServiceTypes,}}));
            }
        // You may want to do setState here as well
        } catch (error) {
        // do something when you encounter errors
        }
    };
    fetchData()
}, []);


useEffect(()=>{

    const statesWithsubStates = Array.isArray(caseStates)? caseStates.filter((e)=> e.subStates.length > 0 && datos.estado?.some((de)=> de === e.stateId ) ) : []

    setSubStates(
        new DataSource(
            {
                store: {
                    type: "array",
                    data: statesWithsubStates
                },
                map: function(itemData) {
                    const subStateGroup = {
                        key: itemData.description,
                        items: itemData.subStates
                    } 
                    return subStateGroup
                }
            }
        )
    )

    const reselectedSubStates = datos.subEstados?.filter((substate)=> statesWithsubStates.some(parentState => parentState.subStates.some(parentSubstates => parentSubstates.subStateId === substate)) )
    const hasSubStates = Array.isArray(reselectedSubStates) && reselectedSubStates.length > 0

setDatos(prevState=>({
    ...prevState,
    subEstados: hasSubStates? reselectedSubStates : undefined
}))

},[datos.estado])

useEffect(()=>{
    if(error === "401"){
        dispatch(dispatchClearError())
        history.push(ROUTE_LOGIN)
    }
    }, [error])

    return (<div style={{margin: "1rem"}}>
        <div style={{margin: "1rem 0"}}>
            <TableForm key={filterKey} defaultStartDate={defaultStartDate} type={type} services={userServices} handleServiceChange={handleServiceChange} provinces={provinces} handleProvinceChange={handleProvinceChange} exportExcel={exportExcel} loadingExport={loadingExcel} handleSubmit={handleSubmit} handleInputClear={handleInputClear} estados={caseStates} entryChannels={entryChannels} datos={datos} checkEnter={checkEnter} handleBoxChange={handleBoxChange} tipo={type} handleInputChange={handleInputChange} handleFechaInicioHastaChange={handleFechaInicioHastaChange} handleFechaIniChange={handleFechaIniChange} handleTaxonomiesChange={handleTaxonomiesChange} handleEntryChannelChange={handleEntryChannelChange} clearFilters={clearFilters} handleSubStateChange={handleSubStateChange}  mostrarBusquedaAvanzada={mostrarBusquedaAvanzada} subEstados={subStates} handlePremiumChange={handlePremiumChange} customers={allCustomers} handleCustomerChange={handleCustomerChange} suppliers={suppliers} supplierServiceTypes={supplierServiceTypes} handleSupplierChange={handleSupplierChange} handleSupplierServiceTypeChange={handleSupplierServiceTypeChange}></TableForm>
        </div>
        <Table enableChangeState={enableChangeState} handleChangeStateCases={handleChangeStateCases} handleSetNotManaged={handleSetNotManaged} handleSelectedRow={handleSelectedRow} caseStates={caseStates} type={type} handleRowClick={handleRowClick} onOptionChanged={onOptionChanged} handleCellClick={handleCellClick}  columnasTabla={columnasTabla} datasource={list.elements} loading={loading} filter={filters}/>
        <CustomPagination pageSize={pageSize} pageIndex={pageIndex} handlePageIndexChange={handlePageIndexChange} handlePageSizeChange={handlePageSizeChange} loading={loading} totalPages={list.totalPages} refreshPage={handleRefreshPage} count={list.totalRecords}/>
        </div>
    )

}

export {TableWrapper}